import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/web-app-dev/custom_web.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud  p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={9} xl={8} xxl={8} className="">
            <h2>
              Looking for a precise cost and timeline estimate for your{" "}
              <span>custom web application development</span> project?
            </h2>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get a Quote
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
